var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMargintop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_5968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5759 18.4541V2.7041H14.6384V3.8291H13.7009V2.7041H12.7634V3.8291H11.8259V2.7041H10.8884V3.8291H9.95093V2.7041H9.01343V3.8291H8.07593V2.7041H7.13843V3.8291H6.20093V2.7041H5.26343V3.8291H4.32593V2.7041H3.38843V3.8291H2.45093V2.7041H1.51343V3.8291H0.575928V18.4541H15.5759ZM1.51343 4.9541H14.6384V17.3291H1.51343V4.9541ZM15.5759 1.5791H14.6384V0.454102H15.5759V1.5791ZM14.6384 2.7041H13.7009V1.5791H14.6384V2.7041ZM13.7009 1.5791H12.7634V0.454102H13.7009V1.5791ZM12.7634 2.7041H11.8259V1.5791H12.7634V2.7041ZM11.8259 1.5791H10.8884V0.454102H11.8259V1.5791ZM10.8884 2.7041H9.95093V1.5791H10.8884V2.7041ZM9.95093 1.5791H9.01343V0.454102H9.95093V1.5791ZM9.01343 2.7041H8.07593V1.5791H9.01343V2.7041ZM8.07593 1.5791H7.13843V0.454102H8.07593V1.5791ZM7.13843 2.7041H6.20093V1.5791H7.13843V2.7041ZM6.20093 1.5791H5.26343V0.454102H6.20093V1.5791ZM5.26343 2.7041H4.32593V1.5791H5.26343V2.7041ZM4.32593 1.5791H3.38843V0.454102H4.32593V1.5791ZM3.38843 2.7041H2.45093V1.5791H3.38843V2.7041ZM2.45093 1.5791H1.51343V0.454102H2.45093V1.5791ZM1.51343 2.7041H0.575928V1.5791H1.51343V2.7041Z",
    fill: "#A4A4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_5968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 -1 15.5759 18.4541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMargintop);
export default __webpack_public_path__ + "static/media/margintop.66362672ecdf120cc90e19ff1aad6326.svg";
export { ForwardRef as ReactComponent };